<h1 i18n="@@upp.families.search.title">Search Hotel Families</h1>

<div class="container-fluid">
  <ama-loading-alert
    [sendingStatus]="(familyDeleteSending$ | async) ?? false"
    message="Loading..."
    i18n-message="@@upp.global.messages.loading"
  >
  </ama-loading-alert>
</div>

<ama-upp-notification
  id="families-search-notification"
  class="col"
  [mainMessages]="mainMessages"
  [notification]="(getNotification() | async)!"
  (closeNotificationEvent)="closeNotification()"
>
</ama-upp-notification>

<ama-ng-upp-families-search-criteria
  (searchFamilies)="searchFamilies($event)"
  (clearFamilies)="clearFamilies()"
  [sendingStatus]="(familySearchSending$ | async) ?? false"
  [lookup]="this.lookup"
  [initialFamilyType]="this.familyHotelType"
>
</ama-ng-upp-families-search-criteria>

@if (!agGridTablesActivated) {
  @if (isHotelPropertiesCodesFamily()) {
    <ama-ng-upp-basic-search-result-table
      [searchResults]="(families$ | async) ?? undefined"
      [selectedNames]="(selectedFamilyNames$ | async) ?? undefined"
      [sendingStatus]="(familyDeleteSending$ | async) ?? false"
      [isLookup]="lookup"
      [lookupValues]="lookupValues"
      [lookupOptions]="lookupOptions"
      [sourceComponent]="getSourceComponent()"
      [entryType]="getHotelPropertyCodesFamilyEntryType()"
      [recordToSearchResult]="recordToSearchResult"
      [entryToUpdateCreator]="propertyCodesFamilyEntryToUpdateCreator"
      [entryToUpdateNameResolver]="propertyCodesFamilyEntryToUpdateNameResolver"
      [copyForbidden]="true"
      (deleteEntry)="deleteFamilyCode($any($event))"
      (clearTableEvent)="clearFamilies()"
      (showDetail)="showFamily($event)"
      (modifyDetail)="modifyFamily($event)"
      [managePermission]="managePermission"
      [displayableFields]="displayableFields"
    >
    </ama-ng-upp-basic-search-result-table>
  } @else {
    <ama-ng-upp-basic-search-result-table
      [searchResults]="(families$ | async) ?? undefined"
      [selectedNames]="(selectedFamilyNames$ | async) ?? undefined"
      [sendingStatus]="(familyDeleteSending$ | async) ?? false"
      [isLookup]="lookup"
      [lookupValues]="lookupValues"
      [lookupOptions]="lookupOptions"
      [sourceComponent]="getSourceComponent()"
      [entryType]="getHotelChainsFamilyEntryType()"
      [recordToSearchResult]="recordToSearchResult"
      [entryToUpdateCreator]="chainsFamilyEntryToUpdateCreator"
      [entryToUpdateNameResolver]="chainsFamilyEntryToUpdateNameResolver"
      [copyForbidden]="true"
      (deleteEntry)="deleteFamilyChains($any($event))"
      (clearTableEvent)="clearFamilies()"
      (showDetail)="showFamily($event)"
      (modifyDetail)="modifyFamily($event)"
      [managePermission]="managePermission"
      [displayableFields]="displayableFields"
    >
    </ama-ng-upp-basic-search-result-table>
  }
} @else {
  @if (lookup) {
    <div class="mt-3 mb-3">
      <button class="btn btn-link me-auto p-2" (click)="goBack()">
        <span class="fa-angle-left df-icon-wtd me-2"></span>
        {{ goBackLinkText }}
      </button>
    </div>
  }
  <div class="row mt-7">
    <div id="search-result" class="col">
      <div class="ag-theme-alpine grid-container">
        <ag-grid-angular
          [rowData]="getSearchResults() | async"
          [columnDefs]="columnDefs"
          [gridOptions]="gridOptions"
          [defaultColDef]="defaultColDef"
          (gridReady)="onGridReady($event)"
          class="grid-component"
        ></ag-grid-angular>
      </div>
    </div>
  </div>
}
